import React, { useState, useEffect } from "react";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
} from "firebase/auth";
import { auth } from "../firebase";
import { useNavigate, Link } from "react-router-dom";
import Toast from "../components/Toast/Toast";
import "../styles/Login.css";
import { FcGoogle } from "react-icons/fc";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [toast, setToast] = useState(null); // { message, type }
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // Redirect if already logged in
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        setTimeout(() => navigate("/"), 400); // small delay to allow toast
      }
    });
    return unsub;
  }, [navigate]);

  // Show toast helper
  const showToast = (message, type = "info") => {
    setToast({ message, type });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    showToast("", "info");
    try {
      await signInWithEmailAndPassword(auth, email, password);
      showToast("Signed in successfully!", "success");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      showToast("Invalid email or password.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleSignIn = async () => {
    setIsLoading(true);
    showToast("", "info");
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      showToast("Signed in with Google!", "success");
      setTimeout(() => navigate("/"), 2000);
    } catch (err) {
      showToast("Google sign-in failed.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <form className="login-form" onSubmit={handleSubmit}>
        <h2>Login</h2>
        <input
          type="email"
          placeholder="Email"
          autoComplete="username"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isLoading}
        />
        <input
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          disabled={isLoading}
        />
        {/* Forgot password link */}
        <div style={{ width: "100%", textAlign: "right", marginBottom: "1rem" }}>
          <Link
            to="/forgot-password"
            className="register-reset-link"
            style={{
              color: "#a67800",
              fontSize: "0.98rem",
              textDecoration: "underline",
              cursor: "pointer",
              fontWeight: 500,
            }}
          >
            Forgot password?
          </Link>
        </div>
        <button type="submit" disabled={isLoading}>
          {isLoading ? "Signing In..." : "Sign In"}
        </button>

        <div className="login-divider">
          <span>or</span>
        </div>

        <button
          type="button"
          className="google-signin-btn"
          onClick={handleGoogleSignIn}
          disabled={isLoading}
        >
          <FcGoogle style={{ fontSize: 22, marginRight: 12, verticalAlign: "middle" }} />
          Sign in with Google
        </button>
        <div
  style={{
    marginTop: "1.2rem",
    fontSize: "0.95rem",
    color: "#3c2f1e",
    textAlign: "center",
  }}
>
  Don’t have an account?{" "}
  <Link
    to="/register"
    style={{
      color: "#a67800",
      fontWeight: 600,
      textDecoration: "underline",
      marginLeft: "0.25rem",
    }}
  >
    Register
  </Link>
</div>

      </form>
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}
